import { EMemberChoicesLabels } from 'affiny-core/modules/api/models/memberchoice/memberchoice.types';
import { getSimpleAnswerFromLabel } from 'affiny-core/modules/helpers/informationList';
import { TAnswersLabels } from 'affiny-core/modules/memberchoices/types';

export const selectYearnings = (memberAnswerLabels: TAnswersLabels) => ({
  sociotestLuxuryDefinition: getSimpleAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.sociotestLuxuryDefinition
  ),
  sociotestLittleWeakness: getSimpleAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.sociotestLittleWeakness
  ),
  sociotestLivingIn: getSimpleAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.sociotestLivingIn
  ),
  sociotestQualityTime: getSimpleAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.sociotestQualityTime
  ),
  sociotestStressManagment: getSimpleAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.sociotestStressManagment
  ),
  sociotestMakeMeHappy: getSimpleAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.sociotestMakeMeHappy
  ),
});

export type IYearnings = ReturnType<typeof selectYearnings>;
